import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'

import intlMessages from './translations'
import withToast from 'src/components/Toast'
import intlMessagesAlt from '../translations'
import Disclaimer from 'src/modals/Disclaimer'
import Loader from 'src/components/Loader/Loader'
import intlMessagesApp from 'src/modules/App/translations'
import { Layout, Container, PageTitle } from 'src/components/Layout'
import ChangeRequestForm from './ChangeRequestForm/ChangeRequestForm'

class Other extends Component {
  state = {
    other: {},
    showDisclaimer: false,
  }

  componentDidUpdate(prevProps) {
    const { intl, submitting, history, successful, toast } = this.props

    if (submitting === false && prevProps.submitting === true && successful) {
      history.push('/changepolicy')
      toast({
        title: intl.formatMessage(intlMessages.changePolicyOtherThankYouTitle),
        description: intl.formatMessage(intlMessages.changePolicyNotificationSuccess),
        status: 'success',
      })
    }

    if (submitting === false && prevProps.submitting === true && !successful) {
      toast({
        message: intl.formatMessage(intlMessagesApp.appErrorTitle),
        description: intl.formatMessage(intlMessagesAlt.changePolicyNotificationError),
        status: 'error',
      })
    }
  }

  handleSubmit = values => {
    this.setState({
      other: values,
      showDisclaimer: true,
    })
  }

  handleCloseDisclaimer = () => {
    this.setState({
      showDisclaimer: false,
    })
  }

  handleSubmitDisclaimer = () => {
    const { document, addOther } = this.props
    const { other } = this.state
    const data = {
      policyId: document.id,
      documentType: document.category || 'other',
      comment: other.commentsText,
    }

    addOther(data)
  }

  render() {
    const { loading, intl, submitting } = this.props
    const { showDisclaimer } = this.state

    return (
      <Layout>
        <PageTitle title={intl.formatMessage(intlMessagesAlt.changePolicyOtherHeadline)} showBack />
        <Container padder className='global-centered-desktop-content'>
          {loading ? (
            <Loader styleVariation='staticWithHeight' />
          ) : (
            <ChangeRequestForm onSubmit={this.handleSubmit} />
          )}
          <Disclaimer
            visible={showDisclaimer}
            loading={submitting}
            skipAfterHoursCheck={true}
            onClose={this.handleCloseDisclaimer}
            onSubmit={this.handleSubmitDisclaimer}
          />
        </Container>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(withToast(Other)))
